import { render, staticRenderFns } from "./rowTableData.vue?vue&type=template&id=720296a8&scoped=true&"
import script from "./rowTableData.vue?vue&type=script&lang=js&"
export * from "./rowTableData.vue?vue&type=script&lang=js&"
import style0 from "./rowTableData.vue?vue&type=style&index=0&id=720296a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720296a8",
  null
  
)

export default component.exports